import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.report');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import html2pdf from 'html2pdf.js';

@Component({
    selector: 'wiz-page-report',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.report/view.scss */
@charset "UTF-8";
:host {
  display: block;
  height: 100%;
}

/* ═══════════════════════════════════════════
   Apple / Toss Inspired Design System — Report
   ═══════════════════════════════════════════ */
/* ── Design Tokens ── */
/* ── Page Shell ── */
.report-page {
  min-height: 100%;
  overflow: auto;
  background: #f5f5f7;
  color: #1d1d1f;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "Pretendard", system-ui, sans-serif;
}

.report-frame {
  max-width: 1100px;
  margin: 0 auto;
  padding: 48px 24px 96px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.report-document {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

/* ── Section Base ── */
.document-section {
  background: #ffffff;
  border-radius: 28px;
  padding: 48px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: none;
  /* Section top divider (colored bar at top of each section except cover) */
}
.document-section:not(.cover-section) {
  border-top: 3px solid rgba(0, 0, 0, 0.06);
}

/* ── Cover Section ── */
.cover-section {
  background: linear-gradient(180deg, #fbfbfd 0%, #ffffff 100%);
  padding: 64px 52px 52px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
}
.cover-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #5856d6 0%, #0071e3 50%, #af52de 100%);
  border-radius: 28px 28px 0 0;
}

.cover-header {
  margin-bottom: 28px;
}

.rail-eyebrow {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: rgba(88, 86, 214, 0.08);
  color: #5856d6;
  margin-bottom: 20px;
}

.cover-headline {
  font-size: 44px;
  font-weight: 700;
  letter-spacing: -0.05em;
  line-height: 1.15;
  background: linear-gradient(135deg, #1d1d1f 0%, #434343 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
}

.cover-body {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* ── Typography ── */
.section-kicker {
  display: inline-flex;
  align-items: center;
  margin: 0 0 16px;
  padding: 7px 16px;
  border-radius: 100px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.section-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.cover-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

/* ── PDF Export Button ── */
@keyframes pdfSpin {
  to {
    transform: rotate(360deg);
  }
}
.pdf-export-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  color: #6e6e73;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
}
.pdf-export-btn svg {
  width: 18px;
  height: 18px;
}
.pdf-export-btn:hover {
  background: #0071e3;
  border-color: #0071e3;
  color: #fff;
  box-shadow: 0 2px 12px rgba(0, 113, 227, 0.25);
}
.pdf-export-btn:disabled {
  cursor: default;
  opacity: 0.6;
  pointer-events: none;
}

.pdf-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(0, 0, 0, 0.08);
  border-top-color: #0071e3;
  border-radius: 50%;
  animation: pdfSpin 0.6s linear infinite;
}

.cover-title {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.04em;
  color: #1d1d1f;
  margin: 0 0 8px;
  line-height: 1.2;
}

.lead {
  font-size: 16px;
  color: #6e6e73;
  line-height: 1.8;
  margin: 0;
  letter-spacing: -0.01em;
}

.sub-heading {
  font-size: 20px;
  font-weight: 700;
  color: #1d1d1f;
  letter-spacing: -0.03em;
  margin: 40px 0 12px;
  padding: 12px 0 12px 16px;
  border-left: 3px solid #af52de;
  background: rgba(175, 82, 222, 0.03);
  border-radius: 0 8px 8px 0;
}

.section-copy {
  font-size: 15px;
  line-height: 1.8;
  color: #6e6e73;
  margin: 10px 0 0;
  letter-spacing: -0.01em;
}
.section-copy.sub {
  font-size: 14px;
  line-height: 1.7;
}

h2 {
  margin: 0 0 4px;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.04em;
  color: #1d1d1f;
  line-height: 1.2;
}

h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: #1d1d1f;
  letter-spacing: -0.02em;
}

/* ── Section Kicker Accents ── */
.section-pipeline .section-kicker,
.cover-section .section-kicker {
  background: rgba(88, 86, 214, 0.1);
  color: #5856d6;
}

.section-ocr .section-kicker {
  background: rgba(0, 113, 227, 0.1);
  color: #0071e3;
}

.section-embed .section-kicker {
  background: rgba(88, 86, 214, 0.1);
  color: #5856d6;
}

.section-metrics .section-kicker {
  background: rgba(0, 113, 227, 0.1);
  color: #0071e3;
}

.section-qa .section-kicker {
  background: rgba(175, 82, 222, 0.1);
  color: #af52de;
}

.section-ops .section-kicker {
  background: rgba(52, 199, 89, 0.1);
  color: #34c759;
}

/* Section top colored border overrides */
.section-pipeline {
  border-top-color: rgba(88, 86, 214, 0.3) !important;
}

.section-ocr {
  border-top-color: rgba(0, 113, 227, 0.3) !important;
}

.section-embed {
  border-top-color: rgba(88, 86, 214, 0.3) !important;
}

.section-metrics {
  border-top-color: rgba(0, 113, 227, 0.3) !important;
}

.section-qa {
  border-top-color: rgba(175, 82, 222, 0.3) !important;
}

.section-ops {
  border-top-color: rgba(52, 199, 89, 0.3) !important;
}

/* ── Definition Table ── */
.definition-table {
  margin-top: 24px;
  border-radius: 20px;
  background: #ffffff;
  overflow: hidden;
  border: 1px solid rgba(88, 86, 214, 0.08);
}

.definition-row {
  display: grid;
  grid-template-columns: 160px 1fr;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  transition: background 0.3s cubic-bezier(0.25, 0.1, 0.25, 1), transform 0.2s ease;
}
.definition-row:last-child {
  border-bottom: none;
}
.definition-row:hover {
  background: rgba(88, 86, 214, 0.03);
  transform: translateX(4px);
}
.definition-row:nth-child(1) .definition-key {
  color: #30b0c7;
  background: rgba(48, 176, 199, 0.06);
}
.definition-row:nth-child(2) .definition-key {
  color: #0071e3;
  background: rgba(0, 113, 227, 0.06);
}
.definition-row:nth-child(3) .definition-key {
  color: #5856d6;
  background: rgba(88, 86, 214, 0.06);
}
.definition-row:nth-child(4) .definition-key {
  color: #34c759;
  background: rgba(52, 199, 89, 0.06);
}

.definition-key {
  padding: 16px 24px;
  font-size: 13px;
  font-weight: 600;
  color: #6e6e73;
  letter-spacing: -0.01em;
  background: rgba(0, 0, 0, 0.015);
}

.definition-value {
  padding: 16px 24px;
  font-size: 14px;
  color: #1d1d1f;
  line-height: 1.6;
}

/* ── Position Grid ── */
.position-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-top: 24px;
}

.position-card {
  padding: 24px;
  border-radius: 20px;
  background: rgba(88, 86, 214, 0.04);
  border: none;
  transition: transform 0.3s cubic-bezier(0.25, 0.1, 0.25, 1), box-shadow 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
}
.position-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}
.position-card h3 {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #aeaeb2;
}
.position-card p {
  margin: 10px 0 0;
  font-size: 15px;
  font-weight: 600;
  color: #1d1d1f;
  line-height: 1.6;
}

/* ── Crystal Flow Pipeline ── */
@keyframes cfEnter {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes cfDashFlow {
  to {
    stroke-dashoffset: -20;
  }
}
.cf-pipeline {
  position: relative;
  margin: 28px 0 12px;
  padding: 40px 32px;
  border-radius: 20px;
  background: linear-gradient(135deg, rgba(48, 176, 199, 0.03), rgba(88, 86, 214, 0.04), rgba(52, 199, 89, 0.03));
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.cf-grid-bg {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(circle, rgba(0, 0, 0, 0.035) 1px, transparent 1px);
  background-size: 24px 24px;
  pointer-events: none;
}

.cf-row {
  display: flex;
  align-items: stretch;
  position: relative;
}

.cf-card {
  flex: 1;
  position: relative;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 0.5px 1px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  transition: transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
  min-width: 0;
}
.cf-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04);
}
.cf-card:hover .cf-icon-glow {
  transform: scale(1.12);
  opacity: 0.35;
}

.cf-accent {
  height: 3px;
  border-radius: 3px 3px 0 0;
}

.cf-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 12px 18px;
  gap: 6px;
}
.cf-body h4, .cf-body p {
  margin: 0;
}

.cf-icon-wrap {
  position: relative;
  margin-bottom: 4px;
}

.cf-icon-glow {
  position: absolute;
  inset: -6px;
  border-radius: 50%;
  opacity: 0.18;
  transition: transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
}

.cf-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  position: relative;
}
.cf-icon svg {
  width: 24px;
  height: 24px;
}

.cf-step {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

.cf-name {
  font-size: 14px;
  font-weight: 650;
  color: #1d1d1f;
  letter-spacing: -0.02em;
  text-align: center;
  line-height: 1.3;
}

.cf-engine {
  font-size: 12px;
  font-weight: 500;
  color: #6e6e73;
  line-height: 1;
}

.cf-tag {
  margin-top: 2px;
}

.cf-connector {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  flex-shrink: 0;
  color: rgba(0, 0, 0, 0.25);
}
.cf-connector svg {
  width: 48px;
  height: 24px;
}

.cf-bridge {
  display: flex;
  justify-content: center;
  margin-left: auto;
  width: calc((100% - 96px) / 3);
  padding: 4px 0;
  color: rgba(0, 0, 0, 0.25);
}
.cf-bridge svg {
  width: 40px;
  height: 56px;
}

.cf-dash-flow {
  animation: cfDashFlow 0.8s linear infinite;
}

.cf-enter {
  opacity: 0;
  animation: cfEnter 0.5s ease-out forwards;
}

/* Crystal Flow color variants */
.cf--source .cf-accent {
  background: linear-gradient(90deg, #30b0c7, #69c9db);
}
.cf--source .cf-icon {
  background: rgba(48, 176, 199, 0.08);
  color: #30b0c7;
}
.cf--source .cf-icon-glow {
  background: rgba(48, 176, 199, 0.2);
}
.cf--source .cf-step {
  background: rgba(48, 176, 199, 0.1);
  color: #30b0c7;
}
.cf--source:hover {
  box-shadow: 0 12px 32px rgba(48, 176, 199, 0.12), 0 2px 4px rgba(0, 0, 0, 0.04);
}

.cf--ocr .cf-accent {
  background: linear-gradient(90deg, #0071e3, #3197ff);
}
.cf--ocr .cf-icon {
  background: rgba(0, 113, 227, 0.08);
  color: #0071e3;
}
.cf--ocr .cf-icon-glow {
  background: rgba(0, 113, 227, 0.2);
}
.cf--ocr .cf-step {
  background: rgba(0, 113, 227, 0.1);
  color: #0071e3;
}
.cf--ocr:hover {
  box-shadow: 0 12px 32px rgba(0, 113, 227, 0.12), 0 2px 4px rgba(0, 0, 0, 0.04);
}

.cf--emb .cf-accent {
  background: linear-gradient(90deg, #5856d6, #9594e5);
}
.cf--emb .cf-icon {
  background: rgba(88, 86, 214, 0.08);
  color: #5856d6;
}
.cf--emb .cf-icon-glow {
  background: rgba(88, 86, 214, 0.2);
}
.cf--emb .cf-step {
  background: rgba(88, 86, 214, 0.1);
  color: #5856d6;
}
.cf--emb:hover {
  box-shadow: 0 12px 32px rgba(88, 86, 214, 0.12), 0 2px 4px rgba(0, 0, 0, 0.04);
}

.cf--vec .cf-accent {
  background: linear-gradient(90deg, #007aff, #4da2ff);
}
.cf--vec .cf-icon {
  background: rgba(0, 122, 255, 0.08);
  color: #007aff;
}
.cf--vec .cf-icon-glow {
  background: rgba(0, 122, 255, 0.2);
}
.cf--vec .cf-step {
  background: rgba(0, 122, 255, 0.1);
  color: #007aff;
}
.cf--vec:hover {
  box-shadow: 0 12px 32px rgba(0, 122, 255, 0.12), 0 2px 4px rgba(0, 0, 0, 0.04);
}

.cf--qa .cf-accent {
  background: linear-gradient(90deg, #af52de, #cd92ea);
}
.cf--qa .cf-icon {
  background: rgba(175, 82, 222, 0.08);
  color: #af52de;
}
.cf--qa .cf-icon-glow {
  background: rgba(175, 82, 222, 0.2);
}
.cf--qa .cf-step {
  background: rgba(175, 82, 222, 0.1);
  color: #af52de;
}
.cf--qa:hover {
  box-shadow: 0 12px 32px rgba(175, 82, 222, 0.12), 0 2px 4px rgba(0, 0, 0, 0.04);
}

.cf--export .cf-accent {
  background: linear-gradient(90deg, #34c759, #6ed989);
}
.cf--export .cf-icon {
  background: rgba(52, 199, 89, 0.08);
  color: #34c759;
}
.cf--export .cf-icon-glow {
  background: rgba(52, 199, 89, 0.2);
}
.cf--export .cf-step {
  background: rgba(52, 199, 89, 0.1);
  color: #34c759;
}
.cf--export:hover {
  box-shadow: 0 12px 32px rgba(52, 199, 89, 0.12), 0 2px 4px rgba(0, 0, 0, 0.04);
}

/* ── Tree Tags ── */
.tree-tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
}
.tree-tag.source {
  background: rgba(48, 176, 199, 0.08);
  color: #30b0c7;
}
.tree-tag.ocr {
  background: rgba(0, 113, 227, 0.08);
  color: #0071e3;
}
.tree-tag.emb, .tree-tag.embs {
  background: rgba(88, 86, 214, 0.08);
  color: #5856d6;
}
.tree-tag.vec {
  background: rgba(0, 122, 255, 0.08);
  color: #007aff;
}
.tree-tag.qa {
  background: rgba(175, 82, 222, 0.08);
  color: #af52de;
}
.tree-tag.export {
  background: rgba(52, 199, 89, 0.08);
  color: #34c759;
}

/* ── Table Card & Report Table ── */
.table-card {
  margin-top: 24px;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  border: none;
}

.table-title {
  padding: 20px 20px 0;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #aeaeb2;
}

.table-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.report-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}
.report-table th {
  padding: 14px 20px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #aeaeb2;
  background: rgba(0, 0, 0, 0.015);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  text-align: left;
}
.report-table td {
  padding: 14px 20px;
  color: #1d1d1f;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  line-height: 1.6;
  vertical-align: top;
}
.report-table tr:last-child td {
  border-bottom: none;
}
.report-table tbody tr:nth-child(even) td {
  background: rgba(0, 0, 0, 0.015);
}
.report-table tr:hover td {
  background: rgba(0, 0, 0, 0.025);
}
.report-table.compact th, .report-table.compact td {
  padding: 10px 20px;
  font-size: 13px;
}
.report-table.compact tbody tr:nth-child(even) td {
  background: rgba(0, 0, 0, 0.015);
}

.metrics-table thead th {
  background: rgba(0, 113, 227, 0.06);
  color: #6e6e73;
  font-size: 11px;
  font-weight: 700;
  padding: 12px 16px;
  white-space: nowrap;
}
.metrics-table td {
  padding: 12px 16px;
  font-size: 13px;
}
.metrics-table tbody tr:nth-child(even) td {
  background: rgba(0, 0, 0, 0.018);
}
.metrics-table tbody tr:hover td {
  background: rgba(0, 113, 227, 0.04);
}
.metrics-table td:nth-child(n+2) {
  font-family: "SF Mono", "Fira Code", monospace;
  font-size: 13px;
  text-align: right;
  font-variant-numeric: tabular-nums;
}
.metrics-table tfoot tr td {
  font-weight: 700;
  background: rgba(0, 113, 227, 0.05) !important;
  border-top: 2px solid rgba(0, 113, 227, 0.15);
  border-bottom: none;
  color: #1d1d1f;
}

.collection-name {
  font-weight: 600;
  color: #1d1d1f;
}

.collection-id {
  font-family: "SF Mono", monospace;
  font-size: 11px;
  color: #aeaeb2;
  margin-top: 2px;
}

.number {
  font-family: "SF Mono", monospace;
  font-variant-numeric: tabular-nums;
}

.is-total {
  font-weight: 700;
}

.col-name {
  min-width: 160px;
}

.col-number {
  min-width: 100px;
  text-align: right;
}

.col-size {
  min-width: 100px;
  text-align: right;
}

/* ── Table Color Themes ── */
.table-card--pipeline .report-table thead th {
  background: rgba(0, 113, 227, 0.06);
}
.table-card--pipeline .report-table tbody tr td:first-child {
  font-weight: 600;
  white-space: nowrap;
  position: relative;
  padding-left: 23px;
}
.table-card--pipeline .report-table tbody tr td:first-child::before {
  content: "";
  position: absolute;
  left: 0;
  top: 8px;
  bottom: 8px;
  width: 3px;
  border-radius: 2px;
}
.table-card--pipeline .report-table tbody tr:nth-child(1) td:first-child::before {
  background: #30b0c7;
}
.table-card--pipeline .report-table tbody tr:nth-child(1) td:first-child {
  color: #30b0c7;
}
.table-card--pipeline .report-table tbody tr:nth-child(2) td:first-child::before {
  background: #0071e3;
}
.table-card--pipeline .report-table tbody tr:nth-child(2) td:first-child {
  color: #0071e3;
}
.table-card--pipeline .report-table tbody tr:nth-child(3) td:first-child::before {
  background: #5856d6;
}
.table-card--pipeline .report-table tbody tr:nth-child(3) td:first-child {
  color: #5856d6;
}
.table-card--pipeline .report-table tbody tr:nth-child(4) td:first-child::before {
  background: #007aff;
}
.table-card--pipeline .report-table tbody tr:nth-child(4) td:first-child {
  color: #007aff;
}
.table-card--pipeline .report-table tbody tr:nth-child(5) td:first-child::before {
  background: #af52de;
}
.table-card--pipeline .report-table tbody tr:nth-child(5) td:first-child {
  color: #af52de;
}
.table-card--pipeline .report-table tbody tr:nth-child(6) td:first-child::before {
  background: #34c759;
}
.table-card--pipeline .report-table tbody tr:nth-child(6) td:first-child {
  color: #34c759;
}

.table-card--chunk .report-table thead th {
  background: rgba(88, 86, 214, 0.06);
  color: #5856d6;
}
.table-card--chunk .report-table tbody tr:nth-child(even) td {
  background: rgba(88, 86, 214, 0.02);
}
.table-card--chunk .report-table tbody tr:hover td {
  background: rgba(88, 86, 214, 0.04);
}

.table-card--metric-def .report-table thead th {
  background: rgba(255, 149, 0, 0.06);
  color: #d67d00;
}
.table-card--metric-def .report-table tbody tr:nth-child(even) td {
  background: rgba(255, 149, 0, 0.02);
}
.table-card--metric-def .report-table tbody tr:hover td {
  background: rgba(255, 149, 0, 0.04);
}

/* ── RP Timeline (numbered list — large number + left border connector) ── */
.rp-timeline {
  margin: 16px 0 12px;
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0 0 0 0;
  background: transparent;
  border-radius: 0;
  box-shadow: none;
  overflow: visible;
  border: none;
  position: relative;
}
.rp-timeline::before {
  display: none;
}

.rp-step {
  display: flex;
  align-items: stretch;
  gap: 0;
  position: relative;
  min-height: 56px;
}

/* ── Left rail: continuous vertical line ── */
.rp-step-marker {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  width: 48px;
  position: relative;
}

/* Continuous rail between steps */
.rp-step:not(:last-child) .rp-step-marker::after {
  content: "";
  position: absolute;
  top: 36px;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
}

.rp-step:not(:first-child) .rp-step-marker::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  height: 10px;
}

.rp-timeline--ocr .rp-step-marker::after,
.rp-timeline--ocr .rp-step:not(:first-child) .rp-step-marker::before {
  background: rgba(0, 113, 227, 0.15);
}

.rp-timeline--embed .rp-step-marker::after,
.rp-timeline--embed .rp-step:not(:first-child) .rp-step-marker::before {
  background: rgba(88, 86, 214, 0.15);
}

.rp-step-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
  margin-top: 10px;
  position: relative;
  z-index: 1;
  border: 2px solid;
}

.rp-step:first-child .rp-step-num {
  margin-top: 2px;
}

.rp-timeline--ocr .rp-step-num {
  background: #ffffff;
  color: #0071e3;
  border-color: rgba(0, 113, 227, 0.3);
}

.rp-timeline--embed .rp-step-num {
  background: #ffffff;
  color: #5856d6;
  border-color: rgba(88, 86, 214, 0.3);
}

/* Connector arrow — hidden (rail replaces it) */
.rp-step-line {
  display: none !important;
}

/* ── Step icon (between marker and card) ── */
.rp-step-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  flex-shrink: 0;
  margin-top: 10px;
}
.rp-step-icon svg {
  width: 15px;
  height: 15px;
}

.rp-step:first-child .rp-step-icon {
  margin-top: 2px;
}

.rp-step-icon--ocr {
  background: rgba(0, 113, 227, 0.07);
  color: #0071e3;
}

.rp-step-icon--embed {
  background: rgba(88, 86, 214, 0.07);
  color: #5856d6;
}

/* ── Content area ── */
.rp-step-card {
  flex: 1;
  min-width: 0;
  padding: 10px 16px 14px;
  border-radius: 0;
  background: transparent;
  margin: 0;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  transition: background 0.3s cubic-bezier(0.25, 0.1, 0.25, 1), padding-left 0.2s ease;
}
.rp-step-card:hover {
  background: rgba(0, 0, 0, 0.015);
  padding-left: 20px;
}
.rp-step-card h4 {
  font-size: 13px;
  font-weight: 600;
  color: #1d1d1f;
  margin: 0 0 3px;
  letter-spacing: -0.02em;
}
.rp-step-card p {
  font-size: 12px;
  line-height: 1.55;
  color: #6e6e73;
  margin: 0;
}

.rp-step:last-child .rp-step-card {
  border-bottom: none;
}

/* ── Card Note Grid & Mini Note ── */
.card-note-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-top: 18px;
}

.mini-note {
  padding: 14px 18px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.02);
  border: none;
  font-size: 13px;
  color: #6e6e73;
  line-height: 1.6;
}

/* ── Storage Tree ── */
.storage-tree {
  padding: 16px 20px;
  border-radius: 0;
  background: rgba(0, 0, 0, 0.02);
  font-family: "SF Mono", "Fira Code", monospace;
  font-size: 13px;
  line-height: 2;
  color: #6e6e73;
  border: none;
}

.tree-line {
  position: relative;
}

.refined {
  font-weight: 600;
  color: #1d1d1f;
}

.note {
  color: #aeaeb2;
  font-style: italic;
  margin: 4px 0 0;
  font-size: 12px;
}

/* ── RP EN Pipeline (station track — circles on horizontal rail) ── */
.rp-en-pipeline {
  margin: 28px 0 12px;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  position: relative;
  overflow: hidden;
  border: none;
  padding: 28px 20px 24px;
}
.rp-en-pipeline::before {
  display: none;
}

.rp-en-pipeline-track {
  display: flex;
  align-items: flex-start;
  position: relative;
  /* Horizontal rail line through all stations */
}
.rp-en-pipeline-track::before {
  content: "";
  position: absolute;
  top: 20px;
  left: 40px;
  right: 40px;
  height: 2px;
}

.rp-en-pipeline--ocr .rp-en-pipeline-track::before {
  background: rgba(0, 113, 227, 0.15);
}

.rp-en-pipeline--embed .rp-en-pipeline-track::before {
  background: rgba(88, 86, 214, 0.15);
}

.rp-en-pipeline--qa .rp-en-pipeline-track::before {
  background: rgba(175, 82, 222, 0.15);
}

.rp-en-pipeline-node {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  min-width: 0;
  z-index: 1;
}

/* Station icon — sits ON the rail line */
.rp-en-pipeline-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 2.5px solid;
  background: #ffffff;
  position: relative;
  z-index: 2;
}
.rp-en-pipeline-icon svg {
  width: 18px;
  height: 18px;
}

.rp-en-icon--ocr {
  border-color: rgba(0, 113, 227, 0.35);
  color: #0071e3;
}

.rp-en-icon--embed {
  border-color: rgba(88, 86, 214, 0.35);
  color: #5856d6;
}

.rp-en-icon--qa {
  border-color: rgba(175, 82, 222, 0.35);
  color: #af52de;
}

/* Number tag — small pill below icon */
.rp-en-pipeline-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-width: 20px;
  height: 18px;
  padding: 0 6px;
  border-radius: 9px;
  font-size: 10px;
  font-weight: 700;
  margin-top: 6px;
  margin-bottom: 6px;
}

.rp-en-num--ocr {
  background: rgba(0, 113, 227, 0.1);
  color: #0071e3;
}

.rp-en-num--embed {
  background: rgba(88, 86, 214, 0.1);
  color: #5856d6;
}

.rp-en-num--qa {
  background: rgba(175, 82, 222, 0.1);
  color: #af52de;
}

.rp-en-pipeline-label {
  font-size: 12px;
  font-weight: 600;
  color: #1d1d1f;
  letter-spacing: -0.02em;
  margin-bottom: 2px;
}

.rp-en-pipeline-sub {
  font-size: 11px;
  color: #aeaeb2;
  font-weight: 500;
}

/* ── RP QA Pipeline (2-col grid with flow bridge) ── */
.rp-qa-pipeline {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: stretch;
  margin-top: 24px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.rp-qa-phase {
  padding: 24px 24px 20px;
}

.rp-qa-phase-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}

.rp-qa-phase-badge {
  display: inline-flex;
  padding: 2px 10px;
  border-radius: 100px;
  font-size: 11px;
  font-weight: 700;
  background: rgba(175, 82, 222, 0.08);
  color: #af52de;
  letter-spacing: 0.04em;
}

.rp-qa-phase-title {
  font-size: 14px;
  font-weight: 600;
  color: #1d1d1f;
  letter-spacing: -0.02em;
}

.rp-qa-lane {
  display: flex;
  flex-direction: column;
}

.rp-qa-step {
  display: flex;
  align-items: stretch;
  gap: 12px;
}

.rp-qa-step-marker {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  width: 28px;
  padding-top: 6px;
}

.rp-qa-step-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
  background: rgba(174, 174, 178, 0.08);
  color: #aeaeb2;
}

.rp-num-admin {
  background: rgba(0, 113, 227, 0.1);
  color: #0071e3;
}

.rp-num-system {
  background: rgba(48, 176, 199, 0.1);
  color: #30b0c7;
}

.rp-num-ai {
  background: rgba(175, 82, 222, 0.1);
  color: #af52de;
}

.rp-num-user {
  background: rgba(52, 199, 89, 0.1);
  color: #34c759;
}

.rp-qa-step-line {
  width: 2px;
  flex: 1;
  min-height: 10px;
  background: rgba(175, 82, 222, 0.12);
  border-radius: 1px;
}

.rp-qa-step-card {
  flex: 1;
  min-width: 0;
  padding: 6px 14px 12px;
  margin-bottom: 4px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.015);
  transition: background 0.3s cubic-bezier(0.25, 0.1, 0.25, 1), transform 0.2s ease;
}
.rp-qa-step-card:hover {
  background: rgba(0, 0, 0, 0.03);
  transform: translateX(3px);
}

.rp-qa-actor-badge {
  display: inline-flex;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.rp-actor-admin {
  background: rgba(0, 113, 227, 0.08);
  color: #0071e3;
}

.rp-actor-system {
  background: rgba(48, 176, 199, 0.08);
  color: #30b0c7;
}

.rp-actor-ai {
  background: rgba(175, 82, 222, 0.08);
  color: #af52de;
}

.rp-actor-user {
  background: rgba(52, 199, 89, 0.08);
  color: #34c759;
}

.rp-qa-step-title {
  font-size: 13px;
  font-weight: 600;
  color: #1d1d1f;
  margin-top: 4px;
}

.rp-qa-step-desc {
  font-size: 12px;
  color: #6e6e73;
  line-height: 1.5;
  margin-top: 2px;
}

/* Bridge connector between phases */
.rp-qa-bridge {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 36px;
  position: relative;
}

.rp-qa-bridge-arrow {
  width: 20px;
  height: 20px;
  color: #af52de;
  flex-shrink: 0;
}

/* ── Metric Summary Grid ── */
.metric-summary-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-top: 24px;
}

.metric-card {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 24px 22px 20px;
  border-radius: 20px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  overflow: hidden;
  transition: transform 0.3s cubic-bezier(0.25, 0.1, 0.25, 1), box-shadow 0.3s cubic-bezier(0.25, 0.1, 0.25, 1), border-color 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
}
.metric-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}
.metric-card[data-index="0"] .metric-card-indicator {
  background: #0071e3;
}
.metric-card[data-index="0"] .metric-card-value {
  color: #0071e3;
}
.metric-card[data-index="0"]:hover {
  border-color: rgba(0, 113, 227, 0.25);
}
.metric-card[data-index="1"] .metric-card-indicator {
  background: #5856d6;
}
.metric-card[data-index="1"] .metric-card-value {
  color: #5856d6;
}
.metric-card[data-index="1"]:hover {
  border-color: rgba(88, 86, 214, 0.25);
}
.metric-card[data-index="2"] .metric-card-indicator {
  background: #af52de;
}
.metric-card[data-index="2"] .metric-card-value {
  color: #af52de;
}
.metric-card[data-index="2"]:hover {
  border-color: rgba(175, 82, 222, 0.25);
}
.metric-card[data-index="3"] .metric-card-indicator {
  background: #34c759;
}
.metric-card[data-index="3"] .metric-card-value {
  color: #34c759;
}
.metric-card[data-index="3"]:hover {
  border-color: rgba(52, 199, 89, 0.25);
}
.metric-card[data-index="4"] .metric-card-indicator {
  background: #30b0c7;
}
.metric-card[data-index="4"] .metric-card-value {
  color: #30b0c7;
}
.metric-card[data-index="4"]:hover {
  border-color: rgba(48, 176, 199, 0.25);
}
.metric-card[data-index="5"] .metric-card-indicator {
  background: #ff9500;
}
.metric-card[data-index="5"] .metric-card-value {
  color: #ff9500;
}
.metric-card[data-index="5"]:hover {
  border-color: rgba(255, 149, 0, 0.25);
}
.metric-card[data-index="6"] .metric-card-indicator {
  background: #ff3b30;
}
.metric-card[data-index="6"] .metric-card-value {
  color: #ff3b30;
}
.metric-card[data-index="6"]:hover {
  border-color: rgba(255, 59, 48, 0.25);
}

.metric-card-indicator {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  border-radius: 20px 20px 0 0;
  background: rgba(0, 0, 0, 0.06);
}

.metric-card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.metric-card-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #aeaeb2;
  margin: 0;
}

.metric-card-value {
  font-size: 30px;
  font-weight: 800;
  letter-spacing: -0.04em;
  color: #1d1d1f;
  line-height: 1;
  font-family: "SF Pro Display", -apple-system, sans-serif;
}

.metric-card-copy {
  font-size: 12px;
  color: #6e6e73;
  line-height: 1.5;
  margin: 10px 0 0;
}

.metric-note-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-top: 16px;
}

/* ── Split Layout ── */
.split-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-top: 20px;
}
.split-layout > * {
  min-width: 0;
}

/* ── Mode Paper ── */
.mode-paper {
  margin-top: 24px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  border: none;
}

.mode-chapter {
  padding: 24px 24px 20px;
}
.mode-chapter:first-child {
  border-right: 1px solid rgba(0, 0, 0, 0.06);
}

.mode-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.mode-token {
  display: inline-flex;
  padding: 3px 10px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 700;
  background: rgba(175, 82, 222, 0.08);
  color: #af52de;
}

.chapter-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.chapter-list li {
  font-size: 14px;
  color: #6e6e73;
  line-height: 1.6;
  padding-left: 16px;
  position: relative;
}
.chapter-list li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 10px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(175, 82, 222, 0.3);
}

.mode-note {
  margin-top: 8px;
  font-size: 13px;
  color: #aeaeb2;
  font-style: italic;
}

/* ── RP Mode Flows ── */
.rp-mode-flows {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 24px;
}

.rp-flow-card {
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  border: none;
  position: relative;
}
.rp-flow-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
}
.rp-flow-card--single::before {
  background: #0071e3;
}
.rp-flow-card--multi::before {
  background: #5856d6;
}

.rp-flow-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px 24px 14px;
}

.rp-flow-badge {
  display: inline-flex;
  padding: 3px 10px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 700;
}
.rp-flow-badge--single {
  background: rgba(0, 113, 227, 0.08);
  color: #0071e3;
}
.rp-flow-badge--multi {
  background: rgba(88, 86, 214, 0.08);
  color: #5856d6;
}

.rp-flow-title {
  font-size: 15px;
  font-weight: 600;
  color: #1d1d1f;
  letter-spacing: -0.01em;
}

.rp-flow-steps {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 0 24px 20px;
}

.rp-flow-step {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.rp-flow-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.rp-flow-card--single .rp-flow-num {
  background: rgba(0, 113, 227, 0.08);
  color: #0071e3;
}

.rp-flow-card--multi .rp-flow-num {
  background: rgba(88, 86, 214, 0.08);
  color: #5856d6;
}

.rp-flow-text {
  font-size: 14px;
  color: #6e6e73;
  line-height: 1.5;
}

/* ── Note ── */
.note {
  margin-top: 12px;
  font-size: 14px;
  color: #6e6e73;
  line-height: 1.7;
  letter-spacing: -0.01em;
}
.note.emphasis {
  padding: 18px 22px;
  border-radius: 16px;
  background: rgba(0, 113, 227, 0.04);
  border-left: 4px solid #0071e3;
  font-weight: 500;
}

/* ── Fade Animation ── */
.pl3-fade {
  opacity: 0;
  animation: pl3FadeIn 0.6s cubic-bezier(0.25, 0.1, 0.25, 1) forwards;
}

@keyframes pl3FadeIn {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/* ── Scroll to Top ── */
.scroll-top-btn {
  position: fixed;
  bottom: 40px;
  right: max(24px, (100vw - 1100px) / 2 - 72px);
  z-index: 100;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(12px);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6e6e73;
  transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.2s ease, color 0.2s ease, opacity 0.3s ease;
  animation: scrollBtnIn 0.3s ease forwards;
}
.scroll-top-btn svg {
  width: 20px;
  height: 20px;
}
.scroll-top-btn:hover {
  transform: translateY(-3px) scale(1.08);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  color: #0071e3;
}
.scroll-top-btn:active {
  transform: translateY(0) scale(0.95);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

@keyframes scrollBtnIn {
  from {
    opacity: 0;
    transform: translateY(16px) scale(0.8);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
/* ── Responsive ── */
@media (max-width: 768px) {
  .report-frame {
    padding: 24px 16px 48px;
    gap: 20px;
  }
  .document-section {
    padding: 28px 20px;
    border-radius: 20px;
  }
  .cover-section {
    padding: 36px 24px;
  }
  .cover-headline {
    font-size: 28px;
  }
  h2 {
    font-size: 22px;
  }
  .position-grid,
  .card-note-grid,
  .split-layout,
  .rp-mode-flows,
  .metric-note-grid {
    grid-template-columns: 1fr;
  }
  .metric-summary-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .definition-row {
    grid-template-columns: 1fr;
  }
  .definition-key {
    background: rgba(0, 0, 0, 0.03);
    padding: 10px 20px 4px;
  }
  .definition-value {
    padding: 4px 20px 14px;
  }
  .en-pipeline {
    padding: 20px;
  }
  .en-pipeline-icon {
    width: 44px;
    height: 44px;
  }
  .en-pipeline-icon svg {
    width: 20px;
    height: 20px;
  }
  .rp-en-pipeline-node {
    padding: 20px 8px 16px;
  }
  .rp-en-pipeline-num {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }
  .rp-step {
    padding: 14px 18px;
  }
  .rp-step-num {
    width: 24px;
    height: 24px;
    font-size: 11px;
  }
  .pl3-seq-flow {
    overflow-x: auto;
  }
  .pl3-seq-node {
    padding: 20px 10px;
  }
  .rp-qa-pipeline {
    grid-template-columns: 1fr;
  }
  .rp-qa-bridge {
    flex-direction: row;
    width: auto;
    height: 36px;
    padding: 0 24px;
  }
  .rp-qa-bridge .rp-qa-bridge-arrow {
    transform: rotate(-90deg);
  }
  .rp-qa-phase {
    padding: 20px;
  }
}`],
})
export class PageReportComponent implements OnInit {
    public showScrollTop = false;
    private scrollEl: any;
    public metricsLoading = true;
    public metricsError = '';
    public collectionStats: any[] = [];
    public totalMetricCards: any[] = [];
    public metricTotals: any = {};
    public exportingSection: string = '';

    public itemDefinition = [
        ['사업 아이템', '한의학 저작도구 플랫폼'],
        ['핵심 가치', '데이터 디지털화와 AI 학습용 QA 데이터셋 자동화'],
        ['적용 범위', '고전, 논문, 임상 자료 등 한의학 데이터 전반'],
        ['주요 산출물', 'Fine-tuning QA, CSV']
    ];

    public positioning = [
        {
            title: '데이터 자산화',
            description: 'PDF와 HWP를 수집해 OCR과 임베딩을 거친 검색 가능한 지식 자산으로 전환'
        },
        {
            title: 'QA 자동 생성',
            description: 'Fine-tuning QA 데이터셋을 자동 생성하고 검수 기반으로 품질을 관리'
        },
        {
            title: '전문가 검수 체계',
            description: '생성 직후 검수, 마감, 다운로드까지 운영 플로우를 하나의 서비스 안에 통합'
        }
    ];

    public pipelineOverview = [
        ['01', '원본 수집', '컬렉션 저장소에 PDF/HWP 원본을 업로드하고 컬렉션 단위로 관리'],
        ['02', 'Vision OCR', 'pypdfium2 200DPI 래스터화 + Gemini 2.5 Flash(PIL 직접) 또는 GPT-4.1(base64 JPEG, detail:high)로 페이지별 텍스트 추출'],
        ['03', '임베딩 청킹', '3가지 OCR 포맷 자동 분기 → 500자/50자 overlap 슬라이딩 윈도우 → 100개 배치 OpenAI 1536차원 벡터 생성'],
        ['04', 'Milvus 적재', 'REST v2 API로 6필드 스키마(id, user_id, file_name, page_number, text, vector) 생성 후 50개 배치 upsert'],
        ['05', 'QA 데이터셋 생성', 'Fine-tuning QA를 라벨 기반 생성 규칙으로 운영'],
        ['06', '검수와 마감', '사용자 검수 후 최종 마감하고 CSV로 내보내기']
    ];

    public pipelineTracks = [
        ['입력 자산', 'PDF / HWP 원문', '컬렉션 스토리지'],
        ['텍스트화', '페이지 이미지 → OCR 텍스트', '*_ocr.json'],
        ['벡터화', '청크 → 임베딩 벡터', '*_embedding.json'],
        ['검색기반', 'Milvus row 적재', 'semantic search / query'],
        ['생성기반', 'Fine-tuning QA', 'qa_pair 저장'],
        ['운영기반', 'Review / Finalize / Export', 'CSV']
    ];

    public pipelineBranches = [
        ['OCR 산출물', '_ocr.json (pages 배열 + page/text/text_length)', '_ocr.json 존재 여부가 완료 판정 기준. 별도 status 파일 없음'],
        ['Embedding 산출물', '_embedding.json + _embedding.status.json', '청크+벡터 본문과 완료 상태(model, chunks수, created_at) 분리 관리'],
        ['Vector 산출물', '_vector.status.json + Milvus get_stats', '문서 완료 수(status 파일)와 청크 row 수(rowCount)를 분리 집계'],
        ['Dataset 산출물', 'Fine-tuning QA', '검수 전 pending 데이터가 qa_pair에 저장']
    ];

    public pipelineNodes = [
        { number: '01', title: '원본 수집', engine: '컬렉션 스토리지', artifact: 'PDF / HWP', tagClass: 'source', icon: 'doc' },
        { number: '02', title: 'Vision OCR', engine: 'pypdfium2 + Gemini', artifact: '*_ocr.json', tagClass: 'ocr', icon: 'scan' },
        { number: '03', title: '임베딩 청킹', engine: 'text-embedding-3-small', artifact: '*_embedding.json', tagClass: 'emb', icon: 'grid' },
        { number: '04', title: 'Milvus 적재', engine: 'Milvus REST v2', artifact: '*_vector.status.json', tagClass: 'vec', icon: 'db' },
        { number: '05', title: 'QA 생성', engine: 'GPT-5 / Gemini Preview', artifact: 'qa_pair', tagClass: 'qa', icon: 'brain' },
        { number: '06', title: '검수/마감', engine: 'Review + Export', artifact: 'CSV', tagClass: 'export', icon: 'check' },
    ];

    public pipelineEnSteps = [
        { label: 'Collect', sub: 'PDF / HWP', tagClass: 'source' },
        { label: 'OCR', sub: 'Vision LLM', tagClass: 'ocr' },
        { label: 'Embed', sub: 'Chunking', tagClass: 'emb' },
        { label: 'Vector DB', sub: 'Milvus', tagClass: 'vec' },
        { label: 'QA Gen', sub: 'Fine-tune', tagClass: 'qa' },
        { label: 'Review', sub: 'Export', tagClass: 'export' },
    ];

    // ─── Per-Section English Pipelines ───
    public ocrPipelineEn = [
        { label: 'Scope', sub: '4 modes', icon: 'target' },
        { label: 'Rasterize', sub: '200 DPI', icon: 'image' },
        { label: 'Vision LLM', sub: 'Gemini / GPT', icon: 'eye' },
        { label: 'Save', sub: '_ocr.json', icon: 'save' },
        { label: 'Isolate', sub: 'Error fence', icon: 'shield' }
    ];

    public embPipelineEn = [
        { label: 'Parse', sub: '3 formats', icon: 'split' },
        { label: 'Chunk', sub: '500 / 50', icon: 'grid' },
        { label: 'Vectorize', sub: '1536-dim', icon: 'cube' },
        { label: 'Save', sub: 'JSON pair', icon: 'save' },
        { label: 'Verify', sub: 'Status check', icon: 'check' }
    ];

    public qaPipelineEn = [
        { label: 'Configure', sub: 'Dataset + Labels', icon: 'config' },
        { label: 'Select', sub: 'Single / Multi', icon: 'search' },
        { label: 'Generate', sub: 'LLM QA', icon: 'brain' },
        { label: 'Review', sub: 'Approve / Reject', icon: 'clipboard' },
        { label: 'Export', sub: 'CSV Download', icon: 'download' }
    ];

    public pipelineRow1 = this.pipelineNodes.slice(0, 3);
    public pipelineRow2 = this.pipelineNodes.slice(3).reverse();

    public processTable = [
        ['원본 수집', '컬렉션 스토리지', 'PDF/HWP 업로드', '원본 파일과 용량 관리'],
        ['OCR', 'Gemini 2.5 Flash / GPT-4.1', 'pypdfium2 200DPI 래스터화 후 Vision LLM 호출. 4가지 scope(file/selected/folder/collection) 지원', '_ocr.json 저장. 파일 단위 에러 격리, SSE 페이지별 진행률'],
        ['임베딩', 'text-embedding-3-small', '3가지 OCR 포맷 분기 → 500자 chunk(50자 overlap) → 100개 배치 API 호출', '_embedding.json + _embedding.status.json 동시 저장'],
        ['벡터 적재', 'Milvus REST v2', '6필드 스키마 + L2 인덱스. 50개 배치 upsert, force/ignore_status 재삽입 로직', '_vector.status.json 기록. sync_vector_status() 복구 기능'],
        ['Fine-tuning 생성', 'GPT-5 / Gemini Preview', '주라벨·보조라벨·single/multi mode 기반 QA 생성', 'question/answer/source 저장'],
        ['검수/마감', 'Review + Export', '승인/반려/건너뜀 후 마감', 'CSV 다운로드']
    ];

    public ocrSteps = [
        ['1', '범위 선택', 'file(개별), selected(폴더+파일 혼합), folder(특정 폴더), collection(전체 재귀) 4가지 scope로 대상 파일 수집. _ocr.json이 있는 파일은 자동 skip', 'target'],
        ['2', '페이지 렌더링', 'pypdfium2로 PDF를 200 DPI(scale=200/72≈2.78x)로 래스터화. 전체 페이지를 PIL Image 리스트로 변환하여 Vision API 입력 준비', 'image'],
        ['3', 'Vision LLM 호출', 'Gemini 2.5 Flash는 PIL Image 직접 전달, GPT-4.1은 base64 JPEG(quality=85) + detail:high로 호출. 클라이언트는 배치 내 lazy 초기화(1회)', 'eye'],
        ['4', '결과 저장', 'pages 배열에 page 번호, text, text_length를 기록한 뒤 {base_name}_ocr.json으로 저장. 별도 status 파일 없음', 'save'],
        ['5', '에러 격리', '파일 단위 try/except로 실패 격리. file_error 이벤트 후 다음 파일 계속 진행. complete 이벤트로 processed/errors/total 집계', 'shield']
    ];

    public ocrDetailCards = [
        ['실행 범위(scope)', 'file(개별), selected(폴더+파일 혼합 os.walk 재귀), folder(특정 폴더), collection(전체 재귀) — scope별 대상 수집 방식이 다름'],
        ['모델·Provider', 'Gemini 2.5 Flash(PIL 직접 전달)와 GPT-4.1(base64 JPEG, detail:high, max_tokens=16384). API 키 존재로 available 판정'],
        ['Lazy 초기화', '배치 내 1회만 OpenAI/Gemini 클라이언트 생성. Ocr 인스턴스는 요청마다 새로 생성되지만 캐시는 배치 내 유효'],
        ['SSE 이벤트', 'start → file_start → page_done(페이지별) → file_done → complete. 파일 실패 시 file_error 후 계속. 치명적 예외 시 error']
    ];

    public embeddingSteps = [
        ['1', 'OCR 포맷 분기', '_ocr.json을 읽어 3가지 포맷(list형 레코드 배열 / dict+pages PDF OCR / dict fallback) 자동 분기. URL 필드(source_url, images 등) 제외', 'split'],
        ['2', '청크 분할', '500자 고정 슬라이딩 윈도우(overlap 50자, 실질 이동 450자). 각 청크에 chunk_id, page, start, end 메타데이터를 함께 기록', 'grid'],
        ['3', '벡터 생성', 'OpenAI text-embedding-3-small에 100개씩 배치 호출. API 응답 순서가 입력 순서와 동일하여 인덱스 기반 매핑', 'cube'],
        ['4', '산출물 저장', '_embedding.json(file, cwd, chunk_size, overlap, chunks 포함)과 _embedding.status.json(status, model, chunks수, created_at) 동시 저장', 'save'],
        ['5', '운영 반영', '_embedding.json 존재로 완료 판정. 텍스트 비어있으면 file_skip(no_text), 이미 완료면 file_skip(already_done), 실패 시 file_error', 'check']
    ];

    public chunkRules = [
        ['Chunk Size', '500자', '한 번에 모델에 전달할 텍스트 길이. 한국어·한문 기준 약 250~350 토큰'],
        ['Overlap', '50자', '앞 청크 끝부분을 다음 청크에 다시 포함. 실질 이동 폭 = 450자'],
        ['Embedding Model', 'text-embedding-3-small', '각 청크를 1536차원 벡터로 변환. API 배치는 100개 단위'],
        ['Milvus Insert', '50개 배치', 'entities/upsert REST v2로 적재. ID는 {coll_id}_{md5(file)[:12]}_{idx} 형식']
    ];

    public metricDefinitions = [
        ['원본 파일 수', '저장소 안의 실제 원본 문서 건수'],
        ['전체 페이지 수', 'source DB의 page_count 합계 기준이며, 없으면 OCR pages 수로 보정'],
        ['원본 용량', '컬렉션 내 원본 PDF/HWP 파일 크기의 총합'],
        ['OCR 수', '_ocr.json 생성 완료 문서 수'],
        ['임베딩 수', '_embedding.json 생성 완료 문서 수'],
        ['벡터 DB 수', '_vector.status.json 기준 완료 문서 수'],
        ['Milvus Row 수', '청크 단위 실제 적재 row 수']
    ];

    public metricInterpretation = [
        ['문서 기준 수치', '원본/OCR/임베딩/벡터 DB는 문서 완료 수 기준'],
        ['청크 기준 수치', 'Milvus Row 수는 실제 검색 대상 청크 수로 문서 수보다 큰 값'],
        ['페이지·용량 지표', '전체 페이지 수와 원본 용량 조합으로 컬렉션별 작업량 및 처리 강도 해석 가능']
    ];

    public storageItems = [
        ['원본', 'document.pdf / hwp'],
        ['OCR', 'document_ocr.json'],
        ['Embedding', 'document_embedding.json'],
        ['Embedding Status', 'document_embedding.status.json'],
        ['Vector Status', 'document_vector.status.json']
    ];

    public qaControlCards = [
        ['1. 데이터셋/컬렉션 선택', '관리자가 데이터셋 상세 화면에서 컬렉션을 연결하고, 그 컬렉션에 적재된 Milvus 벡터 범위를 QA 생성의 검색 대상으로 사용'],
        ['2. 생성 모델 선택', 'GPT-5 계열 또는 Gemini Preview 계열 중 생성 모델을 선택'],
        ['3. 주라벨/보조라벨 구성', '주라벨 7종과 보조라벨 3종을 그룹 단위로 조합해 생성 주제를 정함'],
        ['4. 소스 모드 선택', 'single 또는 multi를 선택해 한 파일 중심 생성인지 다중 파일 융합 생성인지 결정'],
        ['5. 생성 개수/프롬프트 설정', '생성 개수 입력 후 system, 주라벨, 보조라벨 프롬프트를 수정하거나 기본값으로 유지'],
        ['6. 생성 실행', 'SSE 진행 이벤트를 보면서 QA를 생성하고 pending 상태로 저장'],
        ['7. 사용자 검수', '사용자가 승인/반려/건너뜀으로 검수하고 진행률을 채움'],
        ['8. 마감/내보내기', '100% 검수 완료 후 마감하고 CSV로 다운로드']
    ];

    public labelGroups = [
        ['주라벨', 'summary, concept, reasoning, decision, treatment_principle, prescription, procedure', '질문의 중심 유형을 정하는 메인 축'],
        ['보조라벨', 'evidence, compare, safety', '근거 제시, 비교 분석, 안전성 같은 추가 관점을 부여하는 축']
    ];

    public modeCards = [
        {
            key: 'single',
            title: '단일 파일 모드',
            note: '한 문서 내 문맥 일관성과 출처 추적성이 가장 중요한 데이터셋에 적합',
            items: [
                '컬렉션 후보 청크 조회',
                '파일 단위 그룹핑',
                '주라벨과 보조라벨 프롬프트 기준 최고 파일 1개 선택',
                '선택 파일만 재조회하여 컨텍스트 재구성',
                'LLM이 질문-답변 쌍과 source_chunks 생성'
            ]
        },
        {
            key: 'multi',
            title: '다중 파일 모드',
            note: '여러 문서를 함께 엮어 설명해야 하는 고난도 QA 생성에 적합',
            items: [
                'Milvus 후보 청크를 분산 수집해 파일 편향 축소',
                'OpenAI query embedding + Milvus semantic search로 파일 랭킹',
                '실패 시 라벨 관련도 점수화 방식으로 fallback',
                '상위 3개 파일만 다시 query하여 최종 컨텍스트 재구성',
                '중복 출처 제거와 부족한 파일 출처 보강 후 저장'
            ]
        }
    ];

    public qaFlowSteps = [
        ['관리자', '데이터셋 상세 진입', '연결된 컬렉션과 사용할 모델을 선택'],
        ['관리자', '주라벨/보조라벨 선택', '그룹별 프롬프트를 구성하고 source_mode를 결정'],
        ['시스템', 'Milvus 후보 조회', 'query와 semantic search 또는 label relevance로 파일을 선택'],
        ['시스템', '컨텍스트 재구성', '선택된 파일만 다시 조회해 실제 생성 컨텍스트를 재구성'],
        ['AI 모델', 'QA 생성', '질문/답변과 출처 후보를 생성'],
        ['시스템', '저장', 'source_chunks 보정 후 pending 상태로 qa_pair 저장'],
        ['사용자', '검수', '승인/반려/건너뜀으로 검수해 진행률을 올림'],
        ['관리자', '마감/내보내기', '검수 완료 후 finalize하고 학습 포맷으로 다운로드']
    ];

    public qaPhaseConfig = this.qaFlowSteps.slice(0, 4);
    public qaPhaseExec = this.qaFlowSteps.slice(4);

    public diagramTracks = {
        single: ['컬렉션 후보 청크 조회', '상위 1개 파일 선택', '선택 파일 재조회', 'LLM QA 생성', 'source_chunks 저장'],
        multi: ['후보 청크 분산 조회', 'semantic search 랭킹', '상위 3개 파일 선택', '선택 파일 재조회', '중복 제거 + 출처 보강 저장']
    };

    public sourceCompare = [
        ['출처 파일 N개', 'Distinct PDF Count', '실제 서로 다른 파일 개수. source_path 기준 PDF 뷰어 연결'],
        ['근거 청크 M건', 'source_chunks Length', '같은 PDF 내 여러 페이지·청크 참조 가능하므로 파일 수와 상이할 수 있음']
    ];

    public deliverables = [
        ['컬렉션 저장소', '원본 문서와 파생 산출물 저장 구조'],
        ['OCR 산출물', '페이지별 텍스트 JSON'],
        ['임베딩 산출물', '청크 + 벡터 JSON'],
        ['벡터 검색 기반', 'Milvus row 적재 및 query/search'],
        ['QA 데이터셋', 'Fine-tuning QA'],
        ['최종 내보내기', 'CSV']
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadMetrics();
        await this.service.render();
    }

    public formatNumber(value: any): string {
        const parsed = Number(value || 0);
        return parsed.toLocaleString();
    }

    public pipelineMarker(i: number): string {
        return `url(#pipe-arrow-${i})`;
    }

    public formatBytes(value: any): string {
        const bytes = Number(value || 0);
        if (!bytes) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB', 'TB'];
        let size = bytes;
        let unitIndex = 0;
        while (size >= 1024 && unitIndex < units.length - 1) {
            size /= 1024;
            unitIndex += 1;
        }
        const digits = unitIndex === 0 ? 0 : size >= 100 ? 0 : size >= 10 ? 1 : 2;
        return `${size.toFixed(digits)} ${units[unitIndex]}`;
    }

    public statusLabel(item: any): string {
        if (!item?.available) return '미연결';
        if (item.status === 'active') return 'Active';
        if (item.status === 'inactive') return 'Inactive';
        return item.status || '-';
    }

    public async loadMetrics() {
        this.metricsLoading = true;
        this.metricsError = '';
        try {
            const res = await wiz.call('metrics', {});
            if (res.code !== 200) {
                throw new Error(res.data?.message || '운영 지표를 불러오지 못했습니다.');
            }

            const totals = res.data?.totals || {};
            this.metricTotals = totals;
            this.collectionStats = res.data?.collections || [];
            this.totalMetricCards = [
                ['원본 파일', totals.originals || 0, '선정된 6개 컬렉션 기준 실제 원본 문서 건수'],
                ['전체 페이지', totals.pages || 0, 'source page_count 합계 기준 전체 페이지 수'],
                ['원본 용량', this.formatBytes(totals.size_bytes || 0), '컬렉션 원본 PDF/HWP 파일 용량 총합'],
                ['OCR 완료', totals.ocr || 0, 'Vision OCR 결과 파일이 존재하는 문서 건수'],
                ['임베딩 완료', totals.embedding || 0, '임베딩 JSON 산출이 완료된 문서 건수'],
                ['벡터 완료', totals.vector || 0, '벡터 삽입 상태 파일 기준 완료 건수'],
                ['Milvus Rows', totals.milvus_rows || 0, '청크 단위 실제 벡터 적재 row 수']
            ];
        } catch (e: any) {
            this.metricTotals = {};
            this.collectionStats = [];
            this.totalMetricCards = [];
            this.metricsError = e?.message || '운영 지표를 불러오지 못했습니다.';
        } finally {
            this.metricsLoading = false;
            await this.service.render();
        }
    }

    public async onScroll(event: any) {
        this.scrollEl = event.target;
        const show = event.target.scrollTop > 400;
        if (show !== this.showScrollTop) {
            this.showScrollTop = show;
            await this.service.render();
        }
    }

    public scrollToTop() {
        if (this.scrollEl) {
            this.scrollEl.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    public sectionMeta: any = {
        summary: '01_사업개요',
        pipeline: '02_파이프라인',
        ocr: '03_OCR',
        embedding: '04_임베딩',
        metrics: '05_운영지표',
        'fine-tuning': '06_QA생성'
    };

    public async exportSection(sectionId: string) {
        this.exportingSection = sectionId;
        await this.service.render();

        const el = document.getElementById(sectionId);
        if (!el) return;

        const filename = this.sectionMeta[sectionId] || sectionId;

        // Clone the element and apply print-friendly styles
        const clone = el.cloneNode(true) as HTMLElement;
        clone.style.width = '800px';
        clone.style.padding = '40px';
        clone.style.background = '#ffffff';
        clone.style.borderRadius = '0';
        clone.style.boxShadow = 'none';

        // Remove export buttons from clone
        clone.querySelectorAll('.pdf-export-btn').forEach(btn => btn.remove());
        clone.querySelectorAll('.section-head').forEach((head: any) => {
            head.style.display = 'block';
        });

        // Fix backdrop-filter elements (html2canvas can't render them)
        clone.querySelectorAll('*').forEach((node: any) => {
            const style = node.style;
            if (style) {
                // Remove backdrop-filter (causes blank/blurry rendering)
                style.backdropFilter = 'none';
                style.webkitBackdropFilter = 'none';
                // Remove animations
                style.animation = 'none';
                style.transition = 'none';
            }
        });

        // Fix glassmorphism cards
        clone.querySelectorAll('.cf-card').forEach((card: any) => {
            card.style.background = '#ffffff';
            card.style.border = '1px solid #e5e5e5';
        });

        // Fix gradient backgrounds that may render poorly
        clone.querySelectorAll('.cf-pipeline').forEach((pip: any) => {
            pip.style.background = '#f8f9fa';
            pip.style.border = '1px solid #e5e5e5';
        });

        // Remove dot grid pattern background
        clone.querySelectorAll('.cf-grid-bg').forEach((bg: any) => bg.remove());

        // Fix glow elements
        clone.querySelectorAll('.cf-icon-glow').forEach((glow: any) => glow.remove());

        // Fix metric cards
        clone.querySelectorAll('.metric-card').forEach((card: any) => {
            card.style.background = '#ffffff';
            card.style.border = '1px solid #e5e5e5';
            card.style.boxShadow = 'none';
        });

        // Fix position cards
        clone.querySelectorAll('.position-card').forEach((card: any) => {
            card.style.background = '#ffffff';
            card.style.border = '1px solid #e5e5e5';
            card.style.boxShadow = 'none';
        });

        // Fix table cards
        clone.querySelectorAll('.table-card').forEach((card: any) => {
            card.style.background = '#ffffff';
            card.style.border = '1px solid #e5e5e5';
            card.style.boxShadow = 'none';
        });

        // Fix mini-note cards
        clone.querySelectorAll('.mini-note').forEach((card: any) => {
            card.style.background = '#ffffff';
            card.style.border = '1px solid #e5e5e5';
            card.style.boxShadow = 'none';
        });

        // Fix mode-chapter cards
        clone.querySelectorAll('.mode-chapter').forEach((card: any) => {
            card.style.background = '#ffffff';
            card.style.border = '1px solid #e5e5e5';
            card.style.boxShadow = 'none';
        });

        // Fix flow cards
        clone.querySelectorAll('.rp-flow-card').forEach((card: any) => {
            card.style.background = '#ffffff';
            card.style.border = '1px solid #e5e5e5';
            card.style.boxShadow = 'none';
        });

        // Fix rp-en-pipeline cards
        clone.querySelectorAll('.rp-en-pipeline').forEach((card: any) => {
            card.style.background = '#ffffff';
            card.style.border = '1px solid #e5e5e5';
            card.style.boxShadow = 'none';
        });

        // Fix definition table
        clone.querySelectorAll('.definition-table').forEach((card: any) => {
            card.style.background = '#ffffff';
            card.style.border = '1px solid #e5e5e5';
        });

        // Ensure text contrast
        clone.querySelectorAll('.section-copy, .lead, p, h2, h3, h4, span, strong, td, th').forEach((txt: any) => {
            const computed = getComputedStyle(txt);
            if (computed.color && computed.opacity) {
                txt.style.opacity = '1';
            }
        });

        // Append off-screen for rendering
        clone.style.position = 'fixed';
        clone.style.top = '-99999px';
        clone.style.left = '0';
        clone.style.zIndex = '-1';
        document.body.appendChild(clone);

        try {
            await html2pdf().set({
                margin: [10, 8, 10, 8],
                filename: `${filename}.pdf`,
                image: { type: 'png', quality: 1 },
                html2canvas: {
                    scale: 3,
                    useCORS: true,
                    logging: false,
                    backgroundColor: '#ffffff',
                    windowWidth: 880
                },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
            }).from(clone).save();
        } catch (e) {
            console.error('PDF export failed:', e);
        } finally {
            document.body.removeChild(clone);
            this.exportingSection = '';
            await this.service.render();
        }
    }

    public async exportAll() {
        const ids = ['summary', 'pipeline', 'ocr', 'embedding', 'metrics', 'fine-tuning'];
        for (const id of ids) {
            await this.exportSection(id);
        }
    }
}

export default PageReportComponent;